module.exports = __webpack_public_path__ + "static/hero_ready-84ed40a69433c4fd0c0f13967e7f7b19.svg";